<template>
  <div :class="`mt-4 ${cartItems && cartItems.length ? 'mt-md-5' : ''}`">
    <div class="row">
      <div class="col-lg-8 pr-lg-4">
        <div v-if="cartItems && cartItems.length">
          <CartItem
            v-for="(cartItem, index) in cartItems"
            :key="cartItem.id"
            :cart-item="cartItem"
            :index="index + 1"
          />
        </div>

        <div v-else>
          Je reis is nu leeg. Bekijk <a :href="routes.journeys">onze reizen</a> of stel <a :href="routes.customJourney">zelf je reis samen</a>.
        </div>

        <div class="d-flex flex-column flex-md-row mt-3 mt-md-4">
          <a
            v-if="!cartItems.length"
            :href="routes.customJourney"
            class="btn btn--secondary btn--lg order-2 order-md-1 mb-2 mb-md-0 mr-md-auto"
            role="button"
          >
            {{ i18n.addAccommodation }}
          </a>

          <button
            v-if="cartItems.length"
            type="button"
            class="btn btn--transparent btn--lg order-1 order-md-2 mb-2 mb-md-0 ml-auto"
            data-toggle="modal"
            data-target="#shareModal"
          >
            <Icon name="heart" extra-classes="icon--lg mt-nudge-2 mr-2" /> {{ i18n.save }}
          </button>

          <button
            class="btn btn--primary btn--lg order-3"
            type="button"
            :disabled="!cartIsValid"
            @click="onCartStoreClick"
          >
            {{ i18n.continueBooking }}
          </button>
        </div>
      </div>

      <div v-if="cartItems && cartItems.length" class="col-lg-4 mt-4 mt-lg-0">
        <CartSummary :cart="cart" :cart-items="cartItems" />

        <CartContact :image="cart.contactImage" />
      </div>
    </div>

    <TravelOrder />

    <Loader />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Icon from '@/cart/components/Icon.vue';
import CartItem from '@/cart/components/CartItem.vue';
import CartSummary from '@/cart/components/CartSummary.vue';
import CartContact from '@/cart/components/CartContact.vue';
import TravelOrder from '@/cart/components/TravelOrder.vue';
import Loader from '@/cart/components/Loader.vue';

export default {
  components: {
    Icon,
    CartItem,
    CartSummary,
    CartContact,
    TravelOrder,
    Loader,
  },

  computed: {
    ...mapGetters([
      'cart',
      'cartItems',
      'cartIsValid',
    ]),

    containsLockedItem() {
      return !!this.cartItems.filter((cartItem) => cartItem.isLocked).length;
    },
  },

  created() {
    this.getCart();
  },

  methods: {
    ...mapActions([
      'getCart',
      'storeCart',
    ]),

    onCartStoreClick() {
      this.storeCart(this.routes.address);
    },
  }
};
</script>
